import React, {useEffect} from 'react';

import '../../App.css';
import {useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../feature/tools";
import {Status} from "../../feature/project/status";
import {fetchActs} from "../../feature/project/actSlice";
import {ViewMode} from "../common/ViewMode";
import {List, NumericList} from "../common/ListItems";

const Acts = (props: { }) => {

    const dispatch = useAppDispatch()
    const {projectId, storyId} = useParams();
    const acts = useAppSelector(state => state.acts.acts)
    const status = useAppSelector(state => state.acts.status)

    useEffect(() => {
        if (status === Status.Idle && projectId && storyId) {
            dispatch(fetchActs({projectId: parseInt(projectId), storyId: parseInt(storyId)}))
        }
    }, [status, dispatch])

    return (
        <NumericList
            items={acts}
            path={(id) => `/projects/${projectId}/stories/${storyId}/acts/${id}`}
        />
    );
};

export default Acts;